"use client";

import Image from "next/image";
import Link from "next/link";
import { useAuth } from "@/lib/auth-context";

export function SiteHeader() {
  const { user, loading } = useAuth();

  return (
    <header className="sticky top-0 z-50 bg-surface-container-low/90 backdrop-blur-md">
      <nav className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between gap-6">
        <Link href="/" className="shrink-0">
          <Image
            src="/logo.jpg"
            alt="Esprit Potager"
            width={130}
            height={50}
            priority
            className="h-10 md:h-12 w-auto"
          />
        </Link>

        {/* The catalogue hubs sit in the main nav on purpose: they are the
            entry points crawlers follow to the ~100 guide pages. */}
        <div className="hidden md:flex items-center gap-6 lg:gap-7 text-body-md">
          <Link
            href="/#fonctionnalites"
            className="hidden lg:inline text-on-surface hover:text-garden-700 transition-colors"
          >
            Fonctionnalités
          </Link>
          <Link
            href="/legumes"
            className="text-on-surface hover:text-garden-700 transition-colors"
          >
            Légumes
          </Link>
          <Link
            href="/calendrier"
            className="text-on-surface hover:text-garden-700 transition-colors"
          >
            Calendrier
          </Link>
          <Link
            href="/associations"
            className="hidden lg:inline text-on-surface hover:text-garden-700 transition-colors"
          >
            Associations
          </Link>
          <Link
            href="/blog"
            className="text-on-surface hover:text-garden-700 transition-colors"
          >
            Blog
          </Link>
          <Link
            href="/galerie"
            className="text-on-surface hover:text-garden-700 transition-colors"
          >
            Galerie
          </Link>
          <Link
            href="/tarifs"
            className="text-on-surface hover:text-garden-700 transition-colors"
          >
            Tarifs
          </Link>
        </div>

        <div className="flex items-center gap-3">
          {loading ? (
            <span className="w-24 h-9 rounded-xl bg-surface-container animate-pulse" />
          ) : user ? (
            <Link
              href="/dashboard"
              className="bg-primary text-on-primary px-5 py-2.5 rounded-xl text-label-lg font-semibold hover:opacity-90 transition-opacity"
            >
              Mon potager →
            </Link>
          ) : (
            <>
              <Link
                href="/auth/login"
                className="hidden sm:inline-flex text-label-lg text-on-surface hover:text-garden-700 transition-colors px-3 py-2"
              >
                Se connecter
              </Link>
              <Link
                href="/essayer"
                className="bg-primary text-on-primary px-5 py-2.5 rounded-xl text-label-lg font-semibold hover:opacity-90 transition-opacity"
              >
                Commencer
              </Link>
            </>
          )}
        </div>
      </nav>
    </header>
  );
}
